import React, { ReactNode } from "react"
import { useTranslation } from "react-i18next";

//MUI
import { IconButton, Stack, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material";

type InfoPaneActionButtonProps = {
    onClick: (param:any) => any;
    title_ttoken: string;
    icon: ReactNode;
}

const InfoPaneActionButton = (props: InfoPaneActionButtonProps) => {

  const { onClick, title_ttoken, icon} = props;

  const theme = useTheme();
  const mainColor = theme.palette.primary.main;

  const { t } = useTranslation();

  return (
      <Stack
        sx={{ position: "relative" }}
        direction="column"
        alignItems="center"
      >
        <IconButton
          sx={{ border: "1px solid " + mainColor, padding: "5px" }}
          onClick={onClick}
        >
            {icon}
        </IconButton>
        <Typography variant="body2" sx={{ position: "absolute", bottom: -20 }}>
          {t(title_ttoken)}
        </Typography>
      </Stack>
     
  );
};

export default InfoPaneActionButton;
